// extracted by mini-css-extract-plugin
export var danger = "_31-6";
export var lightPink = "_31-a";
export var medium = "_31-j";
export var nearSquare = "_31-m";
export var neutralBlue = "_31-8";
export var neutralYellow = "_31-7";
export var noCapitalize = "_31-1";
export var normal = "_31-2";
export var pill = "_31-0";
export var primary = "_31-3";
export var primaryLight = "_31-4";
export var shadow = "_31-n";
export var small = "_31-k";
export var solidBlack = "_31-i";
export var solidGreen = "_31-d";
export var solidLightBlue = "_31-f";
export var solidNavy = "_31-e";
export var solidOrange = "_31-h";
export var solidPink = "_31-g";
export var solidRed = "_31-b";
export var solidWhite = "_31-9";
export var solidYellow = "_31-c";
export var success = "_31-5";
export var xsmall = "_31-l";